<template>
  <DialogLayout :class-name="'create-job-dialog'" @close="handleClose">
    <template #title>{{ t('job.createDialog.title') }}</template>
    <template #default>
      <div class="create-job-content">
        <div class="label">{{ t('job.createDialog.residenceTypeLabel') }}</div>
        <el-radio-group v-model="formData.residenceType" class="radio-group">
          <el-radio :value="ResidenceType.SPECIFIC_SKILL">
            {{ t('job.createDialog.specificSkill') }}
          </el-radio>
          <el-radio :value="ResidenceType.TECHNICAL_HUMANITIES">
            {{ t('job.createDialog.technicalHumanities') }}
          </el-radio>
          <el-radio :value="ResidenceType.ACTIVITIES_OUTSIDE_STATUS">
            {{ t('job.createDialog.activitiesOutsideStatus') }}
          </el-radio>
        </el-radio-group>
      </div>
    </template>
    <template #footer>
      <el-button @click="handleCancel">
        {{ t('job.createDialog.cancel') }}
      </el-button>
      <el-button type="primary" @click="handleConfirm">
        {{ t('job.createDialog.create') }}
      </el-button>
    </template>
  </DialogLayout>
</template>

<script setup lang="ts">
import { reactive } from 'vue';
import { useI18n } from 'vue-i18n';
import { ElMessage } from 'element-plus';
import DialogLayout from '@/components/business-components/dialog/dialog-layout.vue';
import { ResidenceType } from '@/enum/residence';

const { t } = useI18n();

const emit = defineEmits<{
  cancel: [];
  confirm: [data: any];
  close: [];
}>();

const formData = reactive({
  residenceType: ResidenceType.SPECIFIC_SKILL
});

const handleCancel = () => {
  emit('cancel');
  emit('close');
};

const handleConfirm = () => {
  if (!formData.residenceType) {
    ElMessage.warning(t('job.createDialog.validation.residenceTypeRequired'));
    return;
  }

  emit('confirm', { jobType: formData.residenceType });
  emit('close');
};

const handleClose = () => {
  emit('close');
};
</script>

<style lang="scss" scoped>
.create-job-dialog {
  min-width: 416px;
  background: #ffffff;
  overflow: hidden;
}

.create-job-content {
  .label {
    font-size: 14px;
    color: #262626;
    font-weight: 500;
    margin-bottom: 8px;
  }

  .radio-group {
    display: flex;
    // flex-direction: column;
    gap: 12px;

    :deep(.el-radio) {
      margin-right: 0;
      height: auto;
    }
  }
}
</style>
